"use client";
import { GiSteeringWheel } from "react-icons/gi";
import { FaTruck } from "react-icons/fa";
import { useState } from "react";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import { MainCard } from "../../components/Card/Cards";
export default function Employment() {
  const [activeTab, setActiveTab] = useState(0);
  const navigate = useNavigate()

  const TabButton = ({ title, Icon, isActive, setIsActive }) => {
    return (
      <div
        className={`border-1 border-round-xl cursor-pointer p-3 text-center md:w-6 w-full ${
          isActive
            ? "bg-blue-500  border-blue-500 text-white"
            : "bg-gray-300 border-gray-300 text-black"
        }`}
        onClick={setIsActive}
      >
        <Icon className="text-2xl" />
        <p className="m-0 pt-2 font-semibold">{title}</p>
      </div>
    );
  };

  const jobsData = [    
    {
      title: "Laung Haul Drivers",
      icon: GiSteeringWheel,
      description: "We are looking for Long haul experienced AZ driver.",
      requirements: [
        "Must have at least 1 year verifiable experience",
        "Must have clean CVOR abstract and Criminal record",
        "Must be able to cross Border",
        "Must be Customer centric",
      ],
    },
    {
      title: "Owner Operators",
      icon: FaTruck,
      description:
        "We are looking for experienced Owner Operator to join our team immediately! Earn competitive salary and work in a fantastic team environment by working for us!",
      requirements: [
        "Valid AZ License",
        "Heavy Truck/Trailer",
        "Clear criminal record",
        "2 years verifiable tractor trailer driving experience",
        "Clean Driver's Abstract & CVOR",
      ],
    },
  ];

  return (
    <div>
      <h2 className="text-center">WE ARE LOOKING FOR THE FOLLOWING OPENINGS</h2>
      <MainCard size="md:w-8 w-full">
        <div className="flex gap-3">
          {jobsData?.map((job, index) => (
            <TabButton
              key={index}
              Icon={job?.icon}
              title={job?.title}
              isActive={activeTab === index}
              setIsActive={() => setActiveTab(index)}
            />
          ))}
        </div>  
        <div className="pt-3">
          <h4>{jobsData[activeTab]?.description}</h4>
          <p className="font-semibold">How do you qualify?</p>
          <>
            {jobsData[activeTab]?.requirements?.map((required, index) => (
              <p key={index}>
                <IoMdCheckmarkCircleOutline className="mr-2 text-green-700" />
                {required}
              </p>
            ))}
          </>
        </div>

        <Button label="Apply Now" severity="danger" onClick={()=> navigate("/employment/apply")} />
      </MainCard>
    </div>
  );
}
